<template>
  <div>
    <loading
      :active.sync="loadingApp"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light">
      <div class="left">
        <!-- <router-link :to="{name:'transaction.index'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link> -->
        <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </a>
      </div>
      <div class="pageTitle">Detail Deposit</div>
      <div class="right" v-if="transaction.status == 'WAITING'">
        <a class="headerButton" @click="getDetail($route.params.id)">
          <ion-icon name="sync-sharp"></ion-icon>
        </a>
      </div>
    </div>
    <!-- * App Header -->
    <div id="appCapsule" v-if="loadingApp == false">
      <div
        class="section detail-transaction-section pt-4"
        style="--height:150px;"
      >
        <div class="detail-card">
          <div
            class="listed-detail mt-1"
            v-if="transaction.status == 'WAITING'"
          >
            <div class="icon-wrapper">
              <div class="iconbox bg-warning">
                <ion-icon name="hourglass"></ion-icon>
              </div>
            </div>
            <h3 class="text-center mt-2 mb-1">Menunggu Pembayaran</h3>
          </div>
          <div
            class="listed-detail mt-1"
            v-if="transaction.status == 'SUCCESS'"
          >
            <div class="icon-wrapper">
              <div class="iconbox bg-success">
                <ion-icon name="checkmark"></ion-icon>
              </div>
            </div>
            <h3 class="text-center mt-2 mb-1">Berhasil</h3>
          </div>
          <div
            class="listed-detail mt-1"
            v-if="transaction.status == 'EXPIRED'"
          >
            <div class="icon-wrapper">
              <div class="iconbox bg-danger">
                <ion-icon name="close"></ion-icon>
              </div>
            </div>
            <h3 class="text-center mt-2 mb-1">Kadaluarsa</h3>
          </div>
          <div class="listed-detail mt-1">
            <dd class="mb-0">
              ID Deposit <b class="text-primary">#{{ transaction.id }}</b>
            </dd>
            <dd class="mb-0">
              Status Transkasi<br />
              <div
                class="chip chip-warning"
                v-if="transaction.status == 'WAITING'"
              >
                <span class="chip-label">Menunggu</span>
              </div>
              <div
                class="chip chip-success"
                v-if="transaction.status == 'SUCCESS'"
              >
                <span class="chip-label">Berhasil</span>
              </div>
              <div
                class="chip chip-danger"
                v-if="transaction.status == 'EXPIRED'"
              >
                <span class="chip-label">Kadaluarsa</span>
              </div>
            </dd>
            <dd class="mb-0" v-if="transaction.status != 'SUCCESS'">
              <small
                >Batas Pembayaran
                <b class="text-danger"
                  >{{ transaction.expired_time }} WIB</b
                ></small
              >
            </dd>
          </div>
          <div
            class="listed-detail pb-2 pt-2 text-center"
            v-if="transaction.status == 'WAITING' && transaction.qr_url == null"
          >
            <img
              :src="
                VUE_ENV.VUE_APP_ASSET_URL +
                  '/img/payment/' +
                  transaction.payment.payment_logo
              "
              :alt="transaction.payment.payment_name"
              class="mb-1"
              style="width:30%;"
            /><br />
            <label class="label"
              >No. Rek. Pembayaran
              <b>{{ transaction.payment.payment_name }}</b></label
            >
            <div class="element-copy">
              <input
                type="text"
                class="form-control form-control-lg text-center this-copy"
                style="font-weight:bold;"
                :value="transaction.payment_number"
                readonly
              />
              <button
                class="btn btn-outline-primary shadowed mt-2 mb-1"
                @click="copy"
              >
                Salin No. Rek</button
              ><br />
            </div>
            <dd class="m-0">Atas Nama</dd>
            <h3 class="m-0">{{ transaction.payment.payment_owner }}</h3>
          </div>
          <div
            class="listed-detail pb-2 pt-2 text-center"
            v-if="transaction.status == 'WAITING' && transaction.qr_url != null"
          >
            <h2 class="m-0 text-uppercase">
              {{ transaction.payment.payment_owner }}
            </h2>
            <h5 class="m-0 text-uppercase">
              ID:{{ transaction.payment_number }}
            </h5>
            <small><strong>Screenshoot QR Code ini</strong></small>
            <img
              v-lazyload
              :src="require('@/assets/Loader-3.png')"
              :data-src="transaction.qr_url"
              :alt="transaction.payment.payment_name"
              class="w-75"
            /><br />
            <!-- <img :src="transaction.qr_url" :alt="transaction.payment.payment_name" style="width:75%;"><br> -->
          </div>
          <div
            class="listed-detail pb-0 pt-2 text-center"
            v-if="transaction.status == 'WAITING'"
          >
            <label class="label">Nominal Transfer (Rp)</label>
            <div class="element-copy">
              <input
                type="text"
                class="form-control form-control-lg text-center this-copy"
                style="font-weight:bold;"
                :value="transaction.nominal_transfer"
                readonly
              />
              <p class="mb-0">
                <small><i>Nominal yang harus Anda bayarkan</i></small>
              </p>
              <button
                class="btn btn-outline-primary shadowed mt-1 mb-2"
                @click="copy"
              >
                Salin Nominal</button
              ><br />
            </div>
          </div>
          <div
            class="listed-detail pb-1 pt-2 text-center"
            v-if="transaction.status == 'WAITING'"
          >
            <!-- <h5 class="blink text-danger mb-0">Saldo deposit QRIS tidak dapat digunakan untuk pembelian produk Uang Digital dan Transfer Bank</h5> -->
            <!-- <div class="alert alert-warning text-center" role="alert" style="line-height:1rem">
                            <small>DILARANG melakukan deposit saldo menggunakan dana dari hasil penipuan / pinjaman online, jika terbukti maka deposit tidak akan diproses dan akun akan langsung di BLOKIR PERMANEN</small>
                        </div> -->
            <!-- <h5 class="blink text-danger mb-0">DILARANG melakukan deposit saldo menggunakan dana dari hasil penipuan / pinjaman online, jika terbukti maka saldo akan ditahan dan akun akan langsung di BLOKIR PERMANEN</h5> -->
            <blockquote
              class="blockquote text-center mt-1"
              style="line-height:0.7rem"
              v-if="transaction.status == 'WAITING'"
            >
              <small style="color:#726d79;font-size:11px;"
                ><i
                  >Pastikan Dana yang ditransfer sesuai nominal transfer yang
                  muncul, tanpa dibulatkan, dikurangi atau ditambahkan. Jika
                  terjadi kesalahan nominal transfer atau kesalahan lainnya yang
                  menyebabkan tidak dapat diproses otomatis oleh sistem maka
                  deposit saldo akan diproses 1x24 Jam dari waktu transfer.</i
                ></small
              >
            </blockquote>
          </div>
          <div
            class="listed-detail pb-0 pt-2 text-center"
            style="border-bottom:0px;"
            v-if="transaction.status == 'WAITING'"
          >
            <div class="row">
              <div class="col-6">
                <button
                  class="btn btn-outline-danger btn-block"
                  @click="showDialog('show')"
                >
                  <ion-icon name="close-circle-outline"></ion-icon>
                  Batalkan
                </button>
              </div>
              <div class="col-6">
                <router-link
                  :to="{ name: 'care-center' }"
                  class="btn btn-outline-primary btn-block"
                >
                  <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                  Butuh Bantuan
                </router-link>
              </div>
            </div>
          </div>

          <div
            class="listed-detail"
            style="border-bottom:0px;"
            v-if="transaction.status != 'WAITING'"
          >
            <blockquote class="blockquote p-1 mt-2 mb-1">
              <p class="mb-0">
                <ion-icon name="alert-circle"></ion-icon> Detail Deposit
              </p>
            </blockquote>
            <table>
              <tr>
                <td width="160px">Metode Pembayaran</td>
                <td width="20px">:</td>
                <td>{{ transaction.payment.payment_name }}</td>
              </tr>
              <tr>
                <td width="160px">No. Rek.</td>
                <td width="20px">:</td>
                <td style="word-wrap: break-word">
                  {{ transaction.payment_number }}
                </td>
              </tr>
              <tr>
                <td width="160px">Nominal Request</td>
                <td width="20px">:</td>
                <td>Rp {{ transaction.nominal_request | rupiah }}</td>
              </tr>
              <tr>
                <td width="160px">Angka Unik</td>
                <td width="20px">:</td>
                <td>Rp {{ transaction.unique_topup | rupiah }}</td>
              </tr>
              <tr>
                <td width="160px">Biaya Layanan</td>
                <td width="20px">:</td>
                <td>Rp {{ transaction.biaya_layanan | rupiah }}</td>
              </tr>
              <tr>
                <td width="160px">Nominal Transfer</td>
                <td width="20px">:</td>
                <td>Rp {{ transaction.nominal_transfer | rupiah }}</td>
              </tr>
              <tr>
                <td width="160px">Saldo Diterima</td>
                <td width="20px">:</td>
                <td>
                  <b>Rp {{ transaction.nominal_accepted | rupiah }}</b>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="section inset mt-1" v-if="transaction.status == 'WAITING'">
        <div class="card">
          <div class="card-header">Detail Deposit</div>
          <div class="card-body">
            <table width="100%">
              <tbody>
                <tr>
                  <td width="160px">Nominal</td>
                  <td width="20px">:</td>
                  <td>Rp {{ transaction.nominal_request | rupiah }}</td>
                </tr>
                <tr>
                  <td width="160px">Angka Unik</td>
                  <td width="20px">:</td>
                  <td>Rp {{ transaction.unique_topup | rupiah }}</td>
                </tr>
                <tr>
                  <td width="160px">Biaya Layanan</td>
                  <td width="20px">:</td>
                  <td>Rp {{ transaction.biaya_layanan | rupiah }}</td>
                </tr>
                <tr>
                  <td width="160px">Nominal Transfer</td>
                  <td width="20px">:</td>
                  <td>Rp {{ transaction.nominal_transfer | rupiah }}</td>
                </tr>
                <tr>
                  <td width="160px">Saldo Diterima</td>
                  <td width="20px">:</td>
                  <td>
                    <b>Rp {{ transaction.nominal_accepted | rupiah }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div class="accordion" id="accordion01">
                    <div class="item" v-if="transaction.status == 'WAITING'">
                        <div class="accordion-header">
                            <button class="btn" type="button" data-toggle="collapse" data-target="#accordion1a">
                                <b>Detail Deposit</b>
                            </button>
                        </div>
                        <div id="accordion1a" class="accordion-body collapse show" data-parent="#accordion01">
                            <div class="accordion-content">
                                <table>
                                    <tr>
                                        <td width="160px">Nominal</td>
                                        <td width="20px">:</td>
                                        <td>Rp {{ transaction.nominal_request | rupiah }}</td>
                                    </tr>
                                    <tr>
                                        <td width="160px">Angka Unik</td>
                                        <td width="20px">:</td>
                                        <td>Rp {{ transaction.unique_topup | rupiah }}</td>
                                    </tr>
                                    <tr>
                                        <td width="160px">Biaya Layanan</td>
                                        <td width="20px">:</td>
                                        <td>Rp {{ transaction.biaya_layanan | rupiah }}</td>
                                    </tr>
                                    <tr>
                                        <td width="160px">Nominal Transfer</td>
                                        <td width="20px">:</td>
                                        <td>Rp {{ transaction.nominal_transfer | rupiah }}</td>
                                    </tr>
                                    <tr>
                                        <td width="160px">Saldo Diterima</td>
                                        <td width="20px">:</td>
                                        <td><b>Rp {{ transaction.nominal_accepted | rupiah }}</b></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="item" v-if="transaction.status == 'WAITING' && transaction.description != null">
                        <div class="accordion-header">
                            <button class="btn collapsed" type="button" data-toggle="collapse" data-target="#accordion2a">
                                <b>Cara Pembayaran</b>
                            </button>
                        </div>
                        <div id="accordion2a" class="accordion-body collapse" data-parent="#accordion01">
                            <div class="accordion-content" v-html="transaction.description"></div>
                        </div>
                    </div>
                </div> -->

        <div class="accordion mt-1" id="accordion01">
          <div
            class="item"
            v-if="
              transaction.status == 'WAITING' && transaction.description != null
            "
          >
            <div class="accordion-header">
              <button
                class="btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#accordion2a"
              >
                <b>Petunjuk Pembayaran</b>
              </button>
            </div>
            <div
              id="accordion2a"
              class="accordion-body collapse"
              data-parent="#accordion01"
            >
              <div
                class="accordion-content"
                v-html="transaction.description"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="section inset mt-1 text-center" v-if="transaction.status == 'WAITING'">
                <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                    <h3>PENTING!!</h3>
                    <blockquote class="blockquote text-center mt-1" style="line-height:0.7rem" v-if="transaction.status == 'WAITING'">
                        <small style="color:#726d79;font-size:11px;">Pastikan Dana yang ditransfer sesuai nominal transfer yang muncul, tanpa dibulatkan, dikurangi atau ditambahkan. Jika terjadi kesalahan nominal transfer atau kesalahan lainnya yang menyebabkan tidak dapat diproses otomatis oleh sistem maka deposit saldo akan diproses 1x24 Jam dari waktu transfer.</small>
                    </blockquote>
                    <p class="mb-1">Sudah 15 Menit Saldo Belum Masuk?</p>
                    <router-link :to="{name:'care-center'}" class="btn btn-primary btn-sm">Hubungi Kami</router-link>
                </div>
            </div> -->
    </div>

    <Dialog
      ref="dialog"
      :loading="dialogLoading"
      :title="'Konfirmasi'"
      @confirm="cancelDeposit()"
    >
      <p>
        Tiket Deposit Saldo yang dibatalkan tidak dapat digunakan kembali. Yakin
        ingin membatalkan?
      </p>
    </Dialog>
  </div>
</template>
<script>
import $axios from "./../../../api.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      transaction: {
        payment: {},
      },
      loadingApp: true,
      dialogLoading: false,
    };
  },
  created() {
    this.getDetail(this.$route.params.id);
  },
  computed: {
    ...mapState(["toast", "VUE_ENV"]),
  },
  methods: {
    getDetail(id) {
      this.loadingApp = true;
      $axios
        .get("/transaction/deposit/" + id)
        .then((response) => {
          this.transaction = response.data.data;
          this.loadingApp = false;
        })
        .catch(() => {
          this.loadingApp = false;
        });
    },
    copy: function(e) {
      this.$store.commit("SET_TOAST", { show: false });
      let selectEl = window
        .$(e.target)
        .parents(".element-copy")
        .find(".this-copy")[0];
      selectEl.select();
      document.execCommand("copy");
      this.$store.commit("SET_TOAST", {
        show: true,
        message: "Berhasil disalin",
        tipe: "default",
      });
    },
    showDialog(value) {
      let element = this.$refs.dialog.$el;
      window.$(element).modal(value);
    },
    cancelDeposit() {
      this.dialogLoading = true;
      $axios
        .post("/transaction/deposit/" + this.$route.params.id + "/cancel")
        .then((response) => {
          this.showDialog("hide");
          this.dialogLoading = false;
          this.transaction = response.data.data;
        })
        .catch((error) => {
          this.$store.commit("SET_TOAST", {
            show: true,
            message: error.response.data.message,
            tipe: "default",
            icon: "danger",
          });
          this.showDialog("hide");
          this.dialogLoading = false;
        });
    },
  },
  destroyed() {
    this.$store.commit("RESET_TOAST");
  },
};
</script>
